import * as o from "react";
import n from "../lib/IconBase.es.js";
import a from "../defs/Moon.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(n, { ref: t, ...r, weights: a }));
e.displayName = "MoonIcon";
const s = e;
export {
  s as Moon,
  e as MoonIcon
};
